import { useState, useEffect } from "react";
import { useGetAllSubjectsQuery } from "src/services/SubjectService";

const useSubjects = () => {
    const [subjects, setSubjects] = useState<any[]>([]);
    const [isDataLoading, setIsDataLoading] = useState(true);

    const { data, isLoading, isFetching } = useGetAllSubjectsQuery("");

    useEffect(() => {
        if (isLoading || isFetching) {
            setIsDataLoading(true);
        } else {
            const result: any[] = data?.data;
            setSubjects(result || []);
            setIsDataLoading(false);
        }
    }, [data, isLoading, isFetching]);

    return { subjects, isDataLoading };
};

export default useSubjects;
